/**
 * Helper function to generate Bootstrap-style smart pagination items with ellipsis (...)
 * Returns an array of page numbers and '...' placeholders.
 */
export const getPaginationItems = (currentPage: number, totalPages: number): (number | '...')[] => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const items: (number | '...')[] = [];

  if (currentPage <= 3) {
    // Near start: 1, 2, 3, '...', totalPages
    for (let i = 1; i <= 3; i++) {
      items.push(i);
    }
    items.push('...');
    items.push(totalPages);
  } else if (currentPage >= totalPages - 2) {
    // Near end: 1, '...', totalPages-2, totalPages-1, totalPages
    items.push(1);
    items.push('...');
    for (let i = totalPages - 2; i <= totalPages; i++) {
      items.push(i);
    }
  } else {
    // In middle: 1, '...', currentPage-1, currentPage, currentPage+1, '...', totalPages
    items.push(1);
    items.push('...');
    items.push(currentPage - 1);
    items.push(currentPage);
    items.push(currentPage + 1);
    items.push('...');
    items.push(totalPages);
  }

  return items;
};
